export default function() {}



//////////////////
// WEBPACK FOOTER
// /Users/sharvil/Desktop/fall17/adaptive/assign1/~/d3-shape/src/noop.js
// module id = ../../../../d3-shape/src/noop.js
// module chunks = 3